// Configuration centralisée des liens
export const LINKS = {
  uberEats: 'https://www.ubereats.com/fr/store/le-paradis-bondy/cF4nZzDoWjmkBwZTUOfrLw?diningMode=DELIVERY&sc=SEARCH_SUGGESTION',
  phone: '0141552585',
  phoneDisplay: '01 41 55 25 85',
  directions: 'https://www.google.com/maps/dir//43+Av.+du+Mar%C3%A9chal+de+Lattre+de+Tassigny,+93140+Bondy,+France',
  address: '43 Av. du Maréchal de Lattre de Tassigny, 93140 Bondy, France'
};
